module.exports = __webpack_public_path__ + "static/media/chm-bau32_1.d3aa8614.gif";